import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import {
  ActiveCartService,
  BaseSiteService,
  RoutingService
} from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { Subscription } from 'rxjs';
import * as Constants from '../../../../common/constants/CommonConstants';
import { CartService } from '../../cart/cart.service';
import { CheckoutOrderSummaryService } from './checkout-order-summary.service';
@Component({
  selector: 'app-checkout-order-summary',
  templateUrl: './checkout-order-summary.component.html',
  styleUrls: ['./checkout-order-summary.component.scss'],
})
export class EkCheckoutOrderSummaryComponent implements OnInit {
  public orderSummaryDetails: any = {};
  @Input() cartData: any;
  @Input() isOrderConfirmation: Boolean | undefined;
  @Input() isOrderDetails: Boolean | undefined;
  timedOut: boolean | undefined;
  checkoutTimeOut: any;
  isOrderPlacing: boolean = false;
  userData: any;
  privacyPath: any;
  protected subscription = new Subscription();
  cartId: string | undefined;
  sitecountry: any;
  newCartId: any;
  constructor(
    private cartService: CartService,
    public fb: FormBuilder,
    private idle: Idle,
    private routingService: RoutingService,
    private activeCartService: ActiveCartService,
    private baseSiteService: BaseSiteService,
    public cdf: ChangeDetectorRef,
    public checkoutOrderSummaryService: CheckoutOrderSummaryService,
    private userAccount: UserAccountFacade
  ) {
    this.baseSiteService.getActive().subscribe((baseSiteId) => {
      if (baseSiteId) {
        this.baseSiteService.get(baseSiteId).subscribe((siteData: any) => {
          let checkoutTimeOut = Constants.DEFAULT_CHECKOUT_TIMEOUT;
          if (siteData && siteData.checkoutTimeOut) {
            checkoutTimeOut = siteData.checkoutTimeOut;
          }
          idle.setIdle(Constants.DEFAULT_IDLE_TIMEOUT);
          // sets a timeout period of 10 minutes. after 10 minutes of inactivity, the user will be considered timed out.
          idle.setTimeout(checkoutTimeOut);
        });
      }
    });
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    idle.onIdleEnd.subscribe(() => {
      this.reset();
    });

    idle.onTimeout.subscribe(() => {
      this.timedOut = true;
    });

    this.reset();
  }

  checkoutSubmitForm: FormGroup = this.fb.group({
    termsAndConditions: [true, Validators.requiredTrue],
  });

  get termsAndConditionInvalid(): boolean {
    return this.checkoutSubmitForm.invalid;
  }

  ngOnInit(): void {
    this.sitecountry = window.location.pathname.split('/');
    let path = window.location.pathname.split('/');
    let site = path[1];
    if (site === 'lipton-us') {
      this.privacyPath = "/lipton-us/en/USD/privacyPolicy";
    } else {
      this.privacyPath = "/lipton-pk/en/PKR/privacyPolicy";
    }
    this.orderSummaryDetails = this.cartData;
    this.userAccount.get().subscribe((resp) => {
      if (resp) {
        this.userData = resp;
      }
    });
    this.activeCartService.getActiveCartId().subscribe((cartId) => {
      if (cartId) {
        this.cartId = cartId;
      }
    });
  }


  reorder(): void {
    if (this.isOrderDetails) {
      if (!this.cartId) {
        this.cartService.createNewCart(this.userData.uid).subscribe((newCartId) => {
          this.cartService.loadCarts().subscribe((cartData) => {
            if (cartData) {
              this.newCartId = cartData.carts[0].code;
              this.handleReorder(this.newCartId);
            }
          });
        });
      } else {
        this.handleReorder(this.cartId || this.newCartId);
      }
    }
  }

  private handleReorder(cartId: string): void {
    let entries: { productId: any; requestedQty: any; }[] = [];
    this.orderSummaryDetails?.entries?.map((item: any) => {
      entries.push({
        productId: item?.product?.code,
        requestedQty: item?.quantity,
      });
    });

    let req = {
      reorderEntries: entries,
    };

    this.checkoutOrderSummaryService.reorder(req, this.userData, cartId)
      .subscribe(
        (response) => {
          this.activeCartService.reloadActiveCart();
          this.routingService.go({
            cxRoute: 'cart',
          });
        },
        (error) => {
          console.error('Error during reorder:', error);
          this.activeCartService.reloadActiveCart();
          this.routingService.go({
            cxRoute: 'cart',
          });
          window.location.reload();
        }
      );
  } 

  onPlaceOrder() {
    this.isOrderPlacing = true;
    if (this.timedOut) {
      this.subscription.add(
        this.cartService.updateOrderSimulate().subscribe(
          (simulateResp) => {
            if (simulateResp) {
              this.checkSimulateForErrors(simulateResp);
            }
          },
          (error) => {
            this.isOrderPlacing = false;
            this.cdf.detectChanges();
          }
        )
      );
    } else {
      this.subscription.add(
        this.cartService.onPlaceOrder().subscribe(
          (orderData) => {
            if (orderData) {
              this.checkSimulateForErrors(orderData, true);
            }
          },
          (error) => {
            this.isOrderPlacing = false;
            this.cdf.detectChanges();
          }
        )
      );
    }
    this.cdf.detectChanges();
  }
  checkSimulateForErrors(simulateResp: any, onPlaceOrder?: Boolean) {
    this.isOrderPlacing = false;
    let hasError = simulateResp.entries?.some(
      (obj: any) => obj.isOOS || obj.isPartiallyOOS
    );
    if (hasError) {
      this.routingService.go({
        cxRoute: 'cart',
      });
    } else if (onPlaceOrder) {
      this.cartService.$orderPlaceResponse.next(simulateResp);
      this.routingService.go({
        cxRoute: 'orderConfirmation',
      });
    } else {
      this.reset();
      this.cartService.$orderSimulateResponse.next(simulateResp);
    }
    this.cdf.detectChanges();
  }

  reset() {
    this.idle.watch();
    this.timedOut = false;
  }

  onEditOrderClick() {
    this.activeCartService.reloadActiveCart();
    this.routingService.go({
      cxRoute: 'cart',
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
